// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PropertySetupScreen } from './PropertySetupScreen';
export class PanelSettingsScreen {
    static EditProperties(caller, defaultPage, headerString, parentPanel) {
        return __awaiter(this, void 0, void 0, function* () {
            yield PropertySetupScreen.editProperty(caller, headerString, parentPanel);
            if (caller === null || caller === void 0 ? void 0 : caller.propertiesScreen) {
                caller.propertiesScreen.selectPage(defaultPage);
            }
        });
    }
}
// const PanelSettingsDefaultPage = {
//     General: 0,
//     Filters: 1,
//     Coloring: 2,
//     Alerts: 3,
//     DataBox: 8,
//     AllPrice: 9,
//     VolumeProfile: 10,
//     BarStatistics: 11,
//     VolumeBars: 12,
//     Sesonality: 13,
//     TerceraChartTimeAndSales: 14,
//     BarPattern: 15
// };
